import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Container, Card, Form, Button, Alert, Spinner } from 'react-bootstrap';
import { FiLock, FiEye, FiEyeOff } from 'react-icons/fi';
import { authService } from '../../services/authService';

const ResetPassword = () => {
    const [searchParams] = useSearchParams();
    const token = searchParams.get("token");
    const navigate = useNavigate();

    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [status, setStatus] = useState({ type: '', msg: '' });

    // Sécurité : Vérifier si le token est présent dès le début
    useEffect(() => {
        if (!token) {
            setStatus({ type: 'danger', msg: 'Le lien est invalide ou expiré (token manquant).' });
        }
    }, [token]);

    const handleReset = async (e) => {
        e.preventDefault();
        
        // 1. Validations locales
        if (password !== confirmPassword) {
            return setStatus({ type: 'danger', msg: 'Les mots de passe ne correspondent pas.' });
        }
        if (password.length < 8) {
            return setStatus({ type: 'danger', msg: 'Le mot de passe doit contenir au moins 8 caractères.' });
        }

        setIsSubmitting(true);
        setStatus({ type: '', msg: '' });

        try {
            // 2. Appel API (Notez bien l'objet envoyé : token et newPassword)
            await authService.completePasswordReset({ 
                token: token, 
                newPassword: password 
            });

            setStatus({ type: 'success', msg: 'Mot de passe modifié avec succès ! Redirection vers la page de connexion...' });
            
            // 3. Redirection après un court délai
            setTimeout(() => navigate('/login'), 3000);
        } catch (err) {
            const errorMsg = err.response?.data?.error || 'Une erreur est survenue. Le lien est peut-être expiré.';
            setStatus({ type: 'danger', msg: errorMsg });
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <Container className="d-flex align-items-center justify-content-center min-vh-100">
            <Card style={{ width: '420px' }} className="shadow-lg border-0 rounded-4 overflow-hidden">
                <div style={{ background: '#d90000', height: '6px' }}></div>
                <Card.Body className="p-4">
                    <h3 className="text-center fw-bold mb-4">Nouveau mot de passe</h3>
                    
                    {status.msg && <Alert variant={status.type}>{status.msg}</Alert>}

                    {token && status.type !== 'success' && (
                        <Form onSubmit={handleReset}>
                            <Form.Group className="mb-3">
                                <Form.Label className="small fw-bold">Nouveau mot de passe</Form.Label>
                                <div className="position-relative">
                                    <Form.Control 
                                        type={showPassword ? "text" : "password"}
                                        required 
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)} 
                                        placeholder="Min. 8 caractères"
                                        style={{ paddingRight: '40px' }}
                                    />
                                    <span 
                                        className="position-absolute end-0 top-50 translate-middle-y me-3 cursor-pointer"
                                        onClick={() => setShowPassword(!showPassword)}
                                        style={{ cursor: 'pointer', color: '#6c757d' }}
                                    >
                                        {showPassword ? <FiEyeOff /> : <FiEye />}
                                    </span>
                                </div>
                            </Form.Group>

                            <Form.Group className="mb-4">
                                <Form.Label className="small fw-bold">Confirmer le mot de passe</Form.Label>
                                <Form.Control 
                                    type="password" 
                                    required 
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)} 
                                    placeholder="Répétez le mot de passe"
                                />
                            </Form.Group>

                            <Button 
                                variant="danger" 
                                type="submit" 
                                className="w-100 fw-bold py-2"
                                disabled={isSubmitting}
                            >
                                {isSubmitting ? <Spinner size="sm" /> : 'Réinitialiser le mot de passe'}
                            </Button>
                        </Form>
                    )}

                    {!token && (
                        <Button variant="outline-secondary" className="w-100" onClick={() => navigate('/login')}>
                            Retour au login
                        </Button>
                    )}
                </Card.Body>
            </Card>
        </Container>
    );
};

export default ResetPassword;